/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferProductsResponse } from '../../models/offer-products-response';

export interface GetOfferArticlesGroupedByProduct$Params {
  id: number;
  globalFilter?: string;
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getOfferArticlesGroupedByProduct(http: HttpClient, rootUrl: string, params: GetOfferArticlesGroupedByProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferProductsResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferArticlesGroupedByProduct.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('globalFilter', params.globalFilter, {});
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferProductsResponse>;
    })
  );
}

getOfferArticlesGroupedByProduct.PATH = '/offers/{id}/product-articles';
